/**
 * KissAnimation — 💋 kiss mark pulses in the center while 10 hearts of
 * various sizes float up + drift with a gentle sway. Hearts fade from pink
 * to rose so the entire animation reads warm and affectionate.
 */
export default function KissAnimation({ size = 140 }) {
  // Mix of small/medium/large hearts, colors, and slight L/R drift so it
  // doesn't feel like a straight column.
  const hearts = [
    { emoji: "💗", left: "40%", delay: "0.05s", dx: "-30px", scale: 1.0 },
    { emoji: "💕", left: "60%", delay: "0.12s", dx: "24px",  scale: 0.9 },
    { emoji: "💖", left: "50%", delay: "0.18s", dx: "-8px",  scale: 1.2 },
    { emoji: "💗", left: "35%", delay: "0.28s", dx: "-40px", scale: 0.8 },
    { emoji: "💕", left: "65%", delay: "0.34s", dx: "36px",  scale: 1.1 },
    { emoji: "💓", left: "45%", delay: "0.42s", dx: "-16px", scale: 0.95 },
    { emoji: "💖", left: "55%", delay: "0.5s",  dx: "20px",  scale: 1.3 },
    { emoji: "💗", left: "48%", delay: "0.58s", dx: "-4px",  scale: 0.85 },
    { emoji: "💕", left: "62%", delay: "0.65s", dx: "30px",  scale: 1.0 },
    { emoji: "💗", left: "38%", delay: "0.72s", dx: "-28px", scale: 1.15 },
  ];
  return (
    <div
      className="pointer-events-none"
      style={{ width: size, height: size, position: "relative", overflow: "hidden" }}
    >
      <style>{`
        @keyframes kiss-pulse {
          0%   { transform: scale(0.4) rotate(-10deg); opacity: 0; filter: drop-shadow(0 0 0 rgba(244,63,94,0)); }
          20%  { transform: scale(1.6) rotate(6deg); opacity: 1; filter: drop-shadow(0 0 34px rgba(244,63,94,0.95)); }
          40%  { transform: scale(1.3) rotate(-3deg); opacity: 1; filter: drop-shadow(0 0 28px rgba(236,72,153,0.9)); }
          60%  { transform: scale(1.45) rotate(2deg); opacity: 1; filter: drop-shadow(0 0 32px rgba(244,63,94,0.9)); }
          80%  { transform: scale(1.35) rotate(-1deg); opacity: 0.95; filter: drop-shadow(0 0 26px rgba(236,72,153,0.8)); }
          100% { transform: scale(1) rotate(0deg); opacity: 0; filter: drop-shadow(0 0 0 rgba(244,63,94,0)); }
        }
        @keyframes kiss-heart-float {
          0%   { transform: translate(0, 30px) scale(var(--sc, 1)); opacity: 0; }
          15%  { opacity: 1; }
          60%  { opacity: 1; }
          100% { transform: translate(var(--dx, 0), -140%) scale(calc(var(--sc, 1) * 0.6)); opacity: 0; }
        }
      `}</style>

      {/* Floating hearts */}
      {hearts.map((h, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            left: h.left,
            top: "62%",
            fontSize: `${size * 0.18}px`,
            lineHeight: 1,
            transform: "translateX(-50%)",
            animation: `kiss-heart-float 1.4s ease-out ${h.delay} forwards`,
            "--dx": h.dx,
            "--sc": h.scale,
            filter: `drop-shadow(0 0 8px rgba(244,63,94,0.6))`,
          }}
        >
          {h.emoji}
        </div>
      ))}

      {/* Kiss emoji center */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          fontSize: size * 0.7,
          lineHeight: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: "kiss-pulse 1.4s cubic-bezier(.22,1,.36,1) forwards",
        }}
      >
        💋
      </div>
    </div>
  );
}
